var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
export class DunningHistoryItemDto {
    documentId;
    /** Shared identity vocabulary — carries kind, number, and dunningStage. */
    identity;
    createdAt;
}
__decorate([
    Expose(),
    __metadata("design:type", String)
], DunningHistoryItemDto.prototype, "documentId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningHistoryItemDto.prototype, "identity", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Date)
], DunningHistoryItemDto.prototype, "createdAt", void 0);
export class DunningStatusResponseDto {
    /** Whether the invoice payment is overdue (past dueDate and not paid/cancelled). */
    isOverdue;
    /** Number of days past due. 0 if not overdue. */
    daysOverdue;
    /** Calculated due date (issuedAt + 14 days). ISO date string. */
    dueDate;
    /** Highest DunningStage already issued for this invoice, or null if none. */
    currentDunningStage;
    /** Which dunning stages have already been issued. */
    issuedStages;
    /** Previously issued dunning letters for this invoice. */
    history;
}
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], DunningStatusResponseDto.prototype, "isOverdue", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], DunningStatusResponseDto.prototype, "daysOverdue", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningStatusResponseDto.prototype, "dueDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], DunningStatusResponseDto.prototype, "currentDunningStage", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], DunningStatusResponseDto.prototype, "issuedStages", void 0);
__decorate([
    Expose(),
    Type(() => DunningHistoryItemDto),
    __metadata("design:type", Array)
], DunningStatusResponseDto.prototype, "history", void 0);
//# sourceMappingURL=dunning-status.response.dto.js.map